import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/HomeView.vue";
import Login from "../views/LoginView.vue";
import Events from "../views/EventsView.vue";
import Event from "../views/EventView.vue";
import Scanner from "../views/ScannerView.vue";
import EventAttendees from "../views/EventAttendeesView.vue";
import ProgramAttendees from "../views/ProgramAttendeesView.vue";
import ProgramView from "../views/ProgramView.vue";
import NotFoundComponent from "../components/NotFoundComponent.vue";
import store from "../main.js";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/events",
    name: "Events",
    component: Events,
    meta: { requiresLogin: true },
  },
  {
    path: "/event",
    name: "Event",
    component: Event,
    meta: { requiresLogin: true },
  },
  {
    path: "/scanner",
    name: "Scanner",
    component: Scanner,
    meta: { requiresLogin: true },
  },
  {
    path: "/attendees",
    name: "EventAttendees",
    component: EventAttendees,
    meta: { requiresLogin: true },
  },
  {
    path: "/program",
    name: "ProgramView",
    component: ProgramView,
    meta: { requiresLogin: true },
  },
  {
    path: "/programAttendees",
    name: "ProgramAttendees",
    component: ProgramAttendees,
    meta: { requiresLogin: true },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFoundComponent",
    component: NotFoundComponent,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeResolve(async (to, from, next) => {
  window.scrollTo(0, 0);

  if (to.matched.some((record) => record.meta.requiresLogin)) {
    if (!store.getters.isAuthenticated) return next({ name: "Home" });
    try {
      await store.dispatch("loadParticipantStatuses");
    } catch (_) {
      store.commit("clearSession");
      return next({ name: "Login" });
    }
  }
  if (
    to.matched.some(
      (record) => record.name === "Login" || record.name === "Home"
    ) &&
    store.getters.isAuthenticated
  ) return next({ name: "Events" });
  next();
});

export default router;
